<template>
  <div>
    <div :style="{
                    height: 'calc(100vh - 0px)',
                    background: pc?'url(\'/acnImg/bg.jpg\')':'url(\'/acnImg/bg_m.jpg\') ',
                  }">
      <div v-if="pc" class="mw1200" style="vertical-align:middle">
<div style="vertical-align:middle;text-align: center;position: fixed;left:50%;top:50%;margin-left:-372px;margin-top:-282px">
<img src="/acnImg/PClogonull.png" style="vertical-align:middle;text-align: center" />
<div><span style="margin-right: 60px" ><a-button style="fontSize:24px; background: url('/acnImg/PCbuttEN.png');height:40px; width: 170px;border: 0px" class="i_b" @click="$router.push('/home');select('en-US')"></a-button></span><span style="margin-left: 60px" ><a-button style="fontSize:23px; background: url('/acnImg/PCbuttCN.png'); height:40px; width: 170px;border: 0px" class="i_b" @click="$router.push('/home');select('zh-CN')"></a-button></span></div>
</div>
      </div>
      <div v-else style="padding: 0 70px;text-align: center">
        <div style="font-size: 24px;margin-bottom: 0px;line-height: 30px" v-html="$t('index.p').replace(/&lt;br>/, '').replace(/&lt;br>/, '')"></div>
<div style="vertical-align:middle;text-align: center;position: relative">
<img src="/acnImg/SJlogonull.png" style="vertical-align:middle;text-align: center;margin-top: 45%" />
<div><span style="margin-right: 30px" ><a-button style="fontSize:24px; background: url('/acnImg/PCbuttEN.png'); height:40px;border: 0px; width: 170px" class="i_b" @click="$router.push('/home');select('en-US')"></a-button></span><span style="margin-left: 30px" ><a-button style="fontSize:23px;background: url('/acnImg/PCbuttCN.png'); border: 0px;height:40px; width: 170px" class="i_b" @click="$router.push('/home');select('zh-CN')"></a-button></span></div>
    </div>
  </div>
</div>
</div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'index',
  computed: {
    ...mapGetters(['pc', 'isEn'])
  },
  methods: {
    ...mapMutations(['setLocale']),
    select (value) {
      localStorage.setItem('locale', value)
      this.setLocale(value)
      this.$i18n.locale = value
      this.show = false
    }
  }
}
</script>

<style>
.ant-select-selection {
  background: transparent;
}
.i_b {
  color: #404040;
  background: transparent;
  border: 1px #404040 solid;
  margin-top: 50px;
}

.i_b_c {
  color: #404040;
  background: transparent;
  border: 1px #404040 solid;
  margin-top: 50px;
  font-size: 18px;
  height: 40px;
}

.i_b:hover {
  background: #404040;
  color: #D9D9D9;
  border: none;
}

.i_b_c:hover {
  background: #404040;
  color: #D9D9D9;
  border: none;
}
</style>
